// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__h5TZM"};